import React, { useContext, useEffect, useState } from "react";
import {
  fetchActiveAMCBs6VIN,
  fetchAvgInvoiceAmountBs6VIN,
  fetchAvgTATBs6PVIN,
  fetchOpenJobcardBs6VIN,
  fetchserviceTATBs6PVIN,
  fetchTotalJobcardBs6PVIN,
  fetchServiceTATNonBs6PVIN,
  fetchtotalJobcardNonBs6PVIN,
  fetchAvgTATNonBs6PVIN,
  fetchactiveAMCnonBs6PVIN,
  fetchOpenJobcardnonBs6PVIN,
  fetchAvgInvoiceAmountNonBs6PVIN,
} from "./PvinKip";
import { FilterContext } from "../../context/Filter";

const ServiceSummary = ({ allData }) => {
  const [filter, setFilter] = useState("All");
  const { SuperArn: parArn, childArn } = useContext(FilterContext);

  const [dataBs6, setDataBs6] = useState(null);
  const [dataNonBs6, setDataNonBs6] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 start as true
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAll = async () => {
      if (!parArn && !childArn) return;
      // setLoading(true);
      setError(null);

      try {
        const [
          serviceTAT_BS6,
          totalJobcard_BS6,
          avgTAT_BS6,
          activeAMC_BS6,
          openJobcard_BS6,
          avgInvoice_BS6,
          serviceTAT_NonBS6,
          totalJobcard_NonBS6,
          avgTAT_NonBS6,
          activeAMC_NonBS6,
          openJobcard_NonBS6,
          avgInvoice_NonBS6,
        ] = await Promise.all([
          fetchserviceTATBs6PVIN(parArn, childArn),
          fetchTotalJobcardBs6PVIN(parArn, childArn),
          fetchAvgTATBs6PVIN(parArn, childArn),
          fetchActiveAMCBs6VIN(parArn, childArn),
          fetchOpenJobcardBs6VIN(parArn, childArn),
          fetchAvgInvoiceAmountBs6VIN(parArn, childArn),
          fetchServiceTATNonBs6PVIN(parArn, childArn),
          fetchtotalJobcardNonBs6PVIN(parArn, childArn),
          fetchAvgTATNonBs6PVIN(parArn, childArn),
          fetchactiveAMCnonBs6PVIN(parArn, childArn),
          fetchOpenJobcardnonBs6PVIN(parArn, childArn),
          fetchAvgInvoiceAmountNonBs6PVIN(parArn, childArn),
        ]);

        setDataBs6({
          serviceTAT: serviceTAT_BS6 ?? 0,
          Total_Jobcard: totalJobcard_BS6 ?? 0,
          Avg_TAT_Non_accidental: avgTAT_BS6 ?? 0,
          Active_AMC: activeAMC_BS6 ?? 0,
          Open_Jobcard: openJobcard_BS6 ?? 0,
          Average_Invoice_Value: avgInvoice_BS6 ?? 0,
        });

        setDataNonBs6({
          serviceTAT: serviceTAT_NonBS6 ?? 0,
          Total_Jobcard: totalJobcard_NonBS6 ?? 0,
          Avg_TAT_Non_accidental: avgTAT_NonBS6 ?? 0,
          Active_AMC: activeAMC_NonBS6 ?? 0,
          Open_Jobcard: openJobcard_NonBS6 ?? 0,
          Average_Invoice_Value: avgInvoice_NonBS6 ?? 0,
        });
      } catch (err) {
        console.error("Error fetching ServiceSummary data:", err);
        setError("Failed to load data");
      } finally {
        // setLoading(false);
      }
    };

    fetchAll();
  }, [parArn, childArn]);

  const selectedData =
    filter === "BS6" ? dataBs6 : filter === "Non BS-6" ? dataNonBs6 : allData;

  const hasData =
    selectedData &&
    Object.values(selectedData).some(
      (v) => v !== 0 && v !== null && v !== undefined
    );

  return (
    <div className="bg-white rounded-lg shadow p-4 sm:p-6 md:p-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-6 gap-3">
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 text-center sm:text-left">
          Service Summary
        </h2>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
        >
          <option>All</option>
          <option>BS6</option>
          <option>Non BS-6</option>
        </select>
      </div>

      {/* Conditional Rendering */}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {[
          ["Average Service TAT (Hrs):", selectedData?.serviceTAT],
          ["# Active AMC:", selectedData?.Active_AMC],
          ["# Total Job Card:", selectedData?.Total_Jobcard],
          ["# Open Job Card:", selectedData?.Open_Jobcard],
          [
            "Average TAT (Hrs) (Non accidental):",
            selectedData?.Avg_TAT_Non_accidental,
          ],
          [
            "Average Invoice Value (Non accidental):",
            Number(
              String(selectedData?.Average_Invoice_Value || "0").replace(
                /[₹,]/g,
                ""
              )
            ).toFixed(2),
          ],
        ].map(([label, value], idx) => (
          <div
            key={idx}
            className="flex justify-between items-center bg-gray-50 rounded-lg p-3 sm:p-4"
          >
            <span className="text-gray-700 text-sm sm:text-base font-medium">
              {label}
            </span>
            <span className="text-gray-900 text-sm sm:text-base font-semibold">
              {value || 0}
            </span>
          </div>
        ))}
      </div>

    </div>
  );
};

export default ServiceSummary;
